import api from '../../../services/api';

export interface RevenueBreakdownParams {
  start_date: string;
  end_date: string;
  channel: string;
  kind: string;
  period_type: string;
}

export interface RevenueBreakdownItem {
  date: string;
  revenue_value: number;
  profit_value: number;
}

export const fetchRevenueBreakdown = async (
  params: RevenueBreakdownParams
): Promise<RevenueBreakdownItem[]> => {
  const response = await api.get('/api/revenue_breakdown', { params });
  return response.data.revenue_breakdown;
};
